import apiService from './api.service';
import type { DashboardData } from '@/types/dashboard';

class DashboardService {
  private readonly baseUrl = '/dashboard';

  /**
   * Obtém todos os dados do dashboard do usuário
   */
  async getDashboardData(): Promise<DashboardData> {
    const response = await apiService.get<DashboardData>(this.baseUrl);
    return response.data;
  }

  /**
   * Atualiza o progresso de uma missão
   */
  async updateMissionProgress(missionId: string, progress: number): Promise<void> {
    await apiService.patch(`/missions/${missionId}/progress/`, { progress });
  }

  /**
   * Marca uma missão como concluída
   */
  async completeMission(missionId: string): Promise<void> {
    await apiService.post(`/missions/${missionId}/complete/`);
  }

  /**
   * Inscreve-se em um workshop
   */
  async enrollWorkshop(workshopId: string): Promise<void> {
    await apiService.post(`/workshops/${workshopId}/enroll/`);
  }
}

export const dashboardService = new DashboardService();
